// © 2026 AttainIP Engineering
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { isAuthenticated } from '@/lib/auth';
import { getLoginUrl } from '@/api/identity';

export function LoginPage() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated()) {
      navigate('/dashboard', { replace: true });
    }
  }, [navigate]);

  const handleLogin = async () => {
    setLoading(true);
    setError('');
    try {
      const redirectUri = `${window.location.origin}${import.meta.env.BASE_URL}auth/callback`;
      const loginData = await getLoginUrl(redirectUri);

      // Store PKCE params for the callback page (same pattern as SS UI)
      sessionStorage.setItem('oauth_state', loginData.state);
      sessionStorage.setItem('oauth_code_verifier', loginData.code_verifier);
      sessionStorage.setItem('oauth_token_endpoint', loginData.token_endpoint);
      sessionStorage.setItem('oauth_client_id', loginData.client_id);
      sessionStorage.setItem('oauth_redirect_uri', redirectUri);

      // Redirect to Azure AD
      window.location.href = loginData.authorization_url;
    } catch (err) {
      setError('Failed to start login. Please try again.');
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="w-full max-w-sm text-center">
        <h1 className="text-2xl font-bold mb-2">Attain IP SelfService Admin</h1>
        <p className="text-sm text-gray-500 mb-8">Platform administration dashboard</p>

        <div className="bg-white p-6 rounded-lg shadow border border-gray-200">
          <button
            onClick={handleLogin}
            disabled={loading}
            className="w-full bg-gray-900 text-white py-2.5 rounded text-sm font-medium hover:bg-gray-800 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? 'Redirecting...' : 'Sign in with Microsoft'}
          </button>

          {error && <p className="mt-3 text-sm text-red-600">{error}</p>}
        </div>

        <p className="mt-4 text-xs text-gray-400">
          Requires <code className="bg-gray-100 px-1 rounded">platform_admin</code> or{' '}
          <code className="bg-gray-100 px-1 rounded">org_admin</code> role
        </p>
      </div>
    </div>
  );
}
